import { ENV } from "../utils";

export class EnvironmentalRiskMatrixIfrsform {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrixIfrs(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-ifrs/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrixIfrs(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix-ifrs`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrixIfrs(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-ifrs/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrixIfrs(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix-ifrs/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesIfrsBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-ifrs-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
